<template>
  <div ref="widgetHolder" />
</template>

<script lang="ts">
import '@eid-easy/eideasy-widget';
import type { PropType } from 'vue';
import { ref, onMounted, onUpdated, defineComponent } from 'vue';

export default defineComponent({
  props: {
    countryCode: {
      type: String,
      required: true,
    },
    language: {
      type: String,
      required: true,
    },
    clientId: {
      type: String,
      required: true,
    },
    docId: {
      type: String,
      required: true,
    },
    sandbox: {
      type: Boolean,
      required: true,
    },
    enabledMethods: {
      type: Object as PropType<{
        signature: string[];
        identification: boolean;
      }>,
      required: true,
    },
    inputValues: {
      type: Object as PropType<{
        idcode: string;
        phone: string;
        email: string;
      }>,
      required: true,
    },
  },
  emits: ['success'],
  setup(props, { emit }) {
    const widgetHolder = ref<HTMLElement>();
    const renderWidget = () => {
      const eidEasyWidget = document.createElement('eideasy-widget');

      const settings = {
        countryCode: props.countryCode,
        language: props.language,
        sandbox: props.sandbox,
        docId: props.docId,
        clientId: props.clientId,
        enabledMethods: props.enabledMethods,
        inputValues: props.inputValues,
        onSuccess: data => {
          emit('success', data);
        },
      };

      Object.keys(settings).forEach(key => {
        eidEasyWidget[key] = settings[key];
      });

      if (widgetHolder.value) {
        widgetHolder.value.innerHTML = '';
        widgetHolder.value.appendChild(eidEasyWidget);
      }
    };

    onUpdated(() => {
      renderWidget();
    });

    onMounted(() => {
      renderWidget();
    });

    return {
      widgetHolder,
    };
  },
});
</script>
